import styled from "styled-components"


const SpotifyBody=styled.div`
display: flex;
`


export{SpotifyBody}